export const isPendingShiftChangeForCell = (request, cell) => {
  if (!request || !cell?.controllerId || !cell?.year || !cell?.month || !cell?.day) return false;

  const responses = [request.responseOfRecipientRequest, request.responseOfSchedulingCoordinator];
  if (responses.includes('REJECTED') || !responses.includes('NONE')) return false;

  // These are calendar dates; avoid timezone conversion when comparing them.
  const date = `${cell.year}-${String(cell.month).padStart(2, '0')}-${String(cell.day).padStart(2, '0')}`;
  return (request.userApplicant?.id === cell.controllerId && request.date1?.slice(0, 10) === date)
    || (request.userRecipientRequest?.id === cell.controllerId && request.date2?.slice(0, 10) === date);
};
